import React, { useState } from 'react';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarSmall.css';

interface ProgressBarSmallProps {
	workflowState: WorkflowState;
}

const ProgressBarSmall = ({ workflowState }: ProgressBarSmallProps) => {
	const [showTooltip, setShowTooltip] = useState(false);

	const getFirstBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.PendingForPolicyTeamApproval.value:
				return 'circle-yellow';
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:	
				return 'circle-red';
			case WorkflowState.PendingAccountOwnerApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.Error.value:
				return 'back-blue';
			default:
				return '';
		}
	};

	const getSecondBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.PendingForPolicyTeamApproval.value:
			case WorkflowState.Cancelled.value:
			case WorkflowState.Rejected.value:
				return '';
			case WorkflowState.PendingAccountOwnerApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
				return 'circle-yellow';
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.Error.value:
				return 'back-blue';
			default:
				return '';
		}
	};

	const getThirdBulletClass = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
				return 'circle-yellow';
			case WorkflowState.Error.value:
				return 'circle-red';
			case WorkflowState.Completed.value:
				return 'circle-green';
			default:
				return '';
		}
	};

	return (
		<div
			className="progress"
			onMouseEnter={() => setShowTooltip(true)}
			onMouseLeave={() => setShowTooltip(false)}
			title=""
		>
			{showTooltip && (
				<div className="tooltip">
					<WorkflowStateBadge fullWidth workflowState={workflowState} />
				</div>
			)}
			<div className="progress-bar-line" />
			<div className={`circle ${getFirstBulletClass()} left-0`} />
			<div className={`circle ${getSecondBulletClass()} left-50`} />
			<div className={`circle ${getThirdBulletClass()} left-100`} />
		</div>
	);
};

export default ProgressBarSmall;
